module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921015651_T.e3c566aa.jpg";